require("./modules/markerclusterer");
require("./vendors/modernizr/modernizr-custom");
window.serviceCentreMap = require("./modules/serviceCentreMap");
window.aggregatedReviewsMap = require("./modules/aggregatedReviewsMap");
window.serviceCentreSearch = require("./modules/serviceCentreSearch");
window.contactUs = require("./modules/contactUs");
window.siteSearch = require("./modules/siteSearch");
window.quote = require("./modules/quote");
window.toolbox = require("./modules/toolbox");
window.subscribeForm = require("./modules/subscribeForm");
window.locationSearchForm = require("./modules/locationSearchForm");
window.storesToolboxMap = require("./modules/storesToolboxMap");
window.serviceCentreDetailMap = require("./modules/serviceCentreDetailMap");

// Main JS entry point
$(function () {
    //$(".c-toolbox__toggle.quote").on("click", function () {
    //    $(".c-toolbox-quote").removeClass("out slideOutRight").addClass("slideInRight");
    //});
    //$(".c-toolbox-quote .close").on("click", function () {
    //    $(".c-toolbox-quote").removeClass("slideInRight").addClass("slideOutRight");
    //});

    //$(".c-toolbox__toggle.track").on("click", function () {
    //    $(".c-toolbox-track").removeClass("out slideOutRight").addClass("slideInRight");
    //});
    //$(".c-toolbox-track .close").on("click", function () {
    //    $(".c-toolbox-track").removeClass("slideInRight").addClass("slideOutRight");
    //});
    //$(".c-toolbox__toggle.enquire").on("click", function () {
    //    $(".c-toolbox-enquire").removeClass("out slideOutRight").addClass("slideInRight");
    //});
    //$(".c-toolbox-enquire .close").on("click", function () {
    //    $(".c-toolbox-enquire").removeClass("slideInRight").addClass("slideOutRight");
    //});

    //$(".c-secondary-navigation__toggle").on("click", function () {
    //	if ($(this).next(".c-secondary-navigation").is(".out, .slideOutRight")) {
    //  	$(this).next(".c-secondary-navigation").removeClass("out slideOutRight").addClass("slideInRight");
    //	} else {
    //		$(this).next(".c-secondary-navigation").removeClass("slideInRight").addClass("slideOutRight");
    //	}
    //});

    $('#accordion').on('shown.bs.collapse', function () {

        var panel = $(this).find('.in');

        $('html, body').animate({
            scrollTop: panel.offset().top -114
        }, 1000);

    });

    $(".js-submit-form").on("click", function () {
        $(this).closest("form").submit();
    });

    $(".js-submit-form").on("click", function () {
        $(this).closest("form").submit();
    });

    $(".js-enter-submit").on("keypress", function (e) {
        var code = e.keyCode || e.which;
        if (code == 13) {
            $(this).closest("form").submit();
        }
    });

    // // Append a class to the containers of all full width grid row that include modules that don't have a rowContainer to allow the padding to stretch to the eddge of the page
     //$(".umb-grid > .grid-section > div > .container > .row").each(function () {
     //    // Wrap any rows with multple columns in a page containers
     //    $("> .column:not(.col-md-12) > div", this).each(function () {
     //        $(this).parents('.container').addClass("multi-column");
     //    });
     //});

     $('.c-banner-carousel').slick({
         autoplay: true,
         autoplaySpeed: 4000,
         dots: true,
        'arrows': false
    });

    $('.c-featured-service-reviews-carousel').slick({
        'prevArrow': '<button type="button" class="slick-arrow slick-prev"><span class="sr-only">Previous</span></button>',
        'nextArrow': '<button type="button" class="slick-arrow slick-next"><span class="sr-only">Next</span></button>'
    });

    function slickCustomNav(slickSlideShow, slideCustomNav) {

        slickSlideShow = $(slickSlideShow);
        slideCustomNav = $(slideCustomNav);

        slideCustomNav.click(function (e) {
            e.preventDefault();
            var slideIndex = $(this).index();
            console.log(slideIndex);
            slickSlideShow.slick('slickGoTo', slideIndex);
        });

        slickSlideShow.on('setPosition', function () {
            var currentSlide = slickSlideShow.slick('slickCurrentSlide');
            slideCustomNav.removeClass("active");
            slideCustomNav.filter(function (index) {
                return index === currentSlide;
            }).addClass("active");
        });
    }

    slickCustomNav(".c-banner-carousel", ".carousel-navigation .banner");

    $(".c-tertiary-navigation__toggle").on("click", function () {
        $(this).parents(".c-primary-navigation__item").addClass("open");
    });

    $(".c-secondary-navigation__toggle").on("click", function () {
        $(this).parents(".c-primary-navigation__item").removeClass("open");
    });

    $(".dropdown-toggle").on("click", function () {
        var parent = $(this).parent();
        parent.siblings().removeClass("open");
        parent.toggleClass("open");
    });

    $(".sub-toggle").on("click", function () {
        var parent = $(this).parents(".dropdown-menu");
        parent.siblings().removeClass("open");
        parent.toggleClass("open");
        $(this).next(".dropdown-submenu").toggleClass("open");
    });

    $(".c-primary-navigation .back-btn").on("click", function () {
        $(".c-tertiary-navigation").removeClass("open");
        var closest = $(this).closest(".open");
        closest.siblings().removeClass("open");
        closest.removeClass("open");
    });

});

var inputs = document.querySelectorAll('.input-file');
Array.prototype.forEach.call(inputs, function (input) {
    var label = input.nextElementSibling,
        labelVal = label.innerHTML;

    input.addEventListener('change', function (e) {
        var fileName = '';
        if (this.files && this.files.length > 1)
            fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
        else
            fileName = e.target.value.split('\\').pop();

        if (fileName)
            label.querySelector('.input').innerHTML = fileName;
        else
            label.innerHTML = labelVal;
    });
});


// Begin From Master.cshtml
$(function () {
  $(".global-site-selector .dropdown-toggle").click(function (e) {
    e.preventDefault();
    $(".global-site-selector").toggleClass("open");
  });

  $(document).click(function (e) {
    if (!$(e.target).closest(".global-site-selector .dropdown-toggle").length) {
      $('.global-site-selector').removeClass('open');
    }
  });


  if (!Modernizr.objectfit) {

    $("div[class^='image-container']").each(function () {

      var $container = $(this);

      $container.find('img').css('opacity', '0');
      $container.addClass('compat-object-fit');
    });
  }

  window.serviceCentreSearch();
  window.toolbox();
  window.contactUs();
  window.subscribeForm();

  $(".c-search-form").submit(function () {
    if ($("#search-collapse").val() === "" && $("#search").val() === "" && ($("#keywords").val() !== undefined && $("#keywords").val() === "")) {
      return false;
    }
  });

  $(".c-site-search-form").submit(function () {
    if ($("#search-collapse").val() === "" && $("#search").val() === "" && ($("#keywords").val() !== undefined && $("#keywords").val() === "")) {
      return false;
    }
  });
});

// Begin HomeHero
$(function () {
  window.quote();


  $.validator.messages.required = 'Required';
  $.validator.messages.max = 'Invalid';
  $.validator.messages.min = 'Invalid';
  $.validator.messages.number = 'Invalid';
  $.validator.messages.digits = 'Invalid';
  $.validator.messages.maxlength = 'Invalid';
  $.validator.messages.minlength = 'Invalid';
  $.validator.messages.rangelength = 'Invalid';
  $.validator.messages.range = 'Invalid';

  if (window.loginLinksSelectorSnippet)
    return;

  window.loginLinksSelectorSnippet = {};

  $(".login-links-selector-dropdown-button").click(function (e) {
    e.preventDefault();
    $(".login-links-selector-dropdown").toggleClass("open");
  });

  $(document).click(function (e) {
    if (!$(e.target).closest(".login-links-selector-dropdown-button").length) {
      $('.login-links-selector-dropdown').removeClass('open');
    }
  });


  $('.global-an-close').click(function () {
    document.cookie = "global-an-covid19=x;path=/;secure;samesite=strict";

    $('#global-an-covid19').remove();
  });
});
// End HomeHero

// End From Master.cshtml